module.exports = __webpack_public_path__ + "images/aab65d1e7305a94afde7c49163f71439.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/aktia.png
// module id = 1511
// module chunks = 1